import React, { useEffect, useState, useMemo } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import FbAddProductService from "../../Middleware/Firebase/FbAddProductService";
import { useNavigate } from "react-router-dom";
// ✅ consume from BusinessContext
import { useBusinessAuth } from "../../Middleware/context/BusinessContext";



export default function FormAddproduct() {

  const navigate = useNavigate();
  // 🔌 Get auth + company profile from context
  const { user, companyProfile, loading: authLoading, profileLoading } = useBusinessAuth();

  // Estados da UI (menu)
  const [menuData, setMenuData] = useState({});
  const [categoriaAtiva, setCategoriaAtiva] = useState("");
  const [subcategoriaAtiva, setSubcategoriaAtiva] = useState("");
  const [produtosAtivos, setProdutosAtivos] = useState([]);
  const [loadingMenu, setLoadingMenu] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [btnGuardar, setBtnGuardar] = useState(false);
  const [taxa, setTaxa] = useState([]);
  const [pais, setPais] = useState([]);

  // Form (padronizado + novos campos)
  const [formData, setFormData] = useState({
    fornecedor:companyProfile?.nome,
    nameProduto: "",
    description: "",
    price: "",
    tipo: "",            // categoria
    category: "",        // especificação do produto
    subtype: "",         // subcategoria
    currency: "",
    imgAlt: [],          // array de URLs
    img: "",
    idSupplier: null,    // vem do user.uid
    transportadora: ["Tou Aki Express"],
    // Novos campos:
    tipoArtigo: "",      // Produto, Agenda...
    destinoVenda: "",    // Apenas Angola, Todos os Países...
    taxa: "",            // "0.05", "0.10", etc.
    size: [],
    color: [],
  });

  // Quando o user muda, injeta o idSupplier
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      idSupplier: user?.uid ?? null,
    }));
  }, [user]);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  //-------------------------------array para imagens --------------------
  const addImageAlt = (url) => {
    const safe = (url || "").trim();
    if (!safe) return;
    setFormData(prev => ({
      ...prev,
      imgAlt: [...new Set([...(prev.imgAlt || []), safe])],
    }));
  };

  const removeImageAlt = (url) => {
    setFormData(prev => ({
      ...prev,
      imgAlt: (prev.imgAlt || []).filter(u => u !== url),
    }));
  };

  //--------------------------------------------------------------------------------

 const addsizeAlt = (size) => {
    const safe = (size || "").trim();
    if (!safe) return;
    setFormData(prev => ({
      ...prev,
      size: [...new Set([...(prev.size || []), safe])],
    }));
  };


  const removesizeAlt = (size) => {
    setFormData(prev => ({
      ...prev,
      size: (prev.size || []).filter(u => u !== size),
    }));
  };

  //------------------------------------------------------------------------------------------
  
 const addcolorAlt = (cor) => {
    const safe = (cor || "").trim();
    if (!safe) return;
    setFormData(prev => ({
      ...prev,
      color: [...new Set([...(prev.color || []), safe])],
    }));
  };


    const removecolorAlt = (cor) => {
    setFormData(prev => ({
      ...prev,
       color: (prev.cor || []).filter(u => u !== cor),
    }));
  };


  //---------------------------------------------------------
  async function handleSubmit(e) {
    e.preventDefault();
    setBtnGuardar(true);
    try {
      const priceNumber = Number(formData.price);  
    const taxaPerc = formData.taxa === "" ? null : Number(formData.taxa);
    const taxaValor = taxaPerc == null || !Number.isFinite(priceNumber)
      ? null
      : priceNumber * (taxaPerc/100);


      // Validações
      if (!formData.idSupplier) {
        alert("Sessão inválida: entre novamente para identificar o fornecedor.");
        return;
      }
      if (!formData.tipo || !formData.subtype) {
        alert("Selecione Categoria e Subcategoria.");
        return;
      }
      if (!formData.category) {
        alert("Selecione a Especificação (produto) dentro da subcategoria.");
        return;
      }
      if (!formData.nameProduto?.trim()) {
        alert("Informe o Nome do Produto.");
        return;
      }
      if (!formData.img) {
        alert("Informe a Imagem Principal (URL).");
        return;
      }
      if (!Number.isFinite(priceNumber) || priceNumber < 0) {
        alert("Preço inválido.");
        return;
      }
      if (!formData.currency) {
        alert("Selecione a moeda.");
        return;
      }
      if (!formData.tipoArtigo) {
        alert("Selecione o tipo de artigo.");
        return;
      }
      if (!formData.destinoVenda) {
        alert("Selecione onde quer vender.");
        return;
      }

      // Payload final
      const payload = {
        ...formData,
        price: priceNumber,
        taxa: taxaValor, // number|null
      };

     await FbAddProductService(payload);
      alert("✅ Produto inserido com sucesso!");
   
     
      // Reset
      setFormData({
    fornecedor:companyProfile?.nome,
    nameProduto: "",
    description: "",
    price: "",
    tipo: "",            // categoria
    category: "",        // especificação do produto
    subtype: "",         // subcategoria
    currency: "",
    imgAlt: [],          // array de URLs
    img: "",
    idSupplier: null,    // vem do user.uid
    transportadora: ["Tou Aki Express"],
    // Novos campos:
    tipoArtigo: "",      // Produto, Agenda...
    destinoVenda: "",    // Apenas Angola, Todos os Países...
    taxa: "",            // "0.05", "0.10", etc.
    size: [],
    color: [],
      });
      setCategoriaAtiva("");
      setSubcategoriaAtiva("");
      setProdutosAtivos([]);

    navigate(0);
    } catch (error) {
      console.error(error);
      alert("❌ Erro ao inserir produto");
    } finally {
      setBtnGuardar(false);
    }
  }

  //--------------carregar extensoes de dados no firebase --------
  useEffect(()=>{


    const extDados=async()=>{ 
    try{

       //  /--------- criar Taxa dinamica ------------------------------
        const taxaSnap = await getDocs(collection(db, "taxa"));
         setTaxa(taxaSnap.docs.map((item,i)=>({
          id:item.id,
          ...item.data()
         })))
         //----------------------Criar Paises de venda dinamico ------------------------
           const paisSnap = await getDocs(collection(db, "pais"));  
         setPais(paisSnap.docs.map((item,i)=>({
          id:item.id,
          ...item.data()
         })))


    }
    catch(err){

      console.log(err)

    }

     }

     extDados()


  },[])

  // --------- FIREBASE: carregar menu ---------
  useEffect(() => {
    let isMounted = true;
    const carregarMenu = async () => {
      setLoadingMenu(true);
      setLoadError("");
      try {
        const menu = {};
        const categoriasSnap = await getDocs(collection(db, "Menu"));

        
       

      
         //---------------------------------------------------------------------



        for (const categoriaDoc of categoriasSnap.docs) {
          const categoria = categoriaDoc.id;
          menu[categoria] = {};

          const subSnap = await getDocs(collection(db, `Menu/${categoria}/subcategoria`));

          for (const subDoc of subSnap.docs) {
            const subcategoria = subDoc.id;

            const produtosSnap = await getDocs(
              collection(db, `Menu/${categoria}/subcategoria/${subcategoria}/produtos`)
            );

            menu[categoria][subcategoria] = produtosSnap.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
          }
        }

        if (isMounted) setMenuData(menu);
      } catch (err) {
        console.error(err);
        if (isMounted) setLoadError("Falha ao carregar menu. Tente novamente.");
      } finally {
        if (isMounted) setLoadingMenu(false);
      }
    };

    carregarMenu();
    return () => { isMounted = false; };
  }, []);

  // Atualiza produtosAtivos quando categoria/sub mudar
  useEffect(() => {
    if (!categoriaAtiva || !subcategoriaAtiva) {
      setProdutosAtivos([]);
      return;
    }
    const produtos = menuData[categoriaAtiva]?.[subcategoriaAtiva] ?? [];
    setProdutosAtivos(produtos);
  }, [categoriaAtiva, subcategoriaAtiva, menuData]);

  const categorias = useMemo(() => Object.keys(menuData || {}), [menuData]);
  const subcategorias = useMemo(
    () => (categoriaAtiva ? Object.keys(menuData[categoriaAtiva] || {}) : []),
    [menuData, categoriaAtiva]
  );

  const isDisabled =
    loadingMenu || authLoading || profileLoading || btnGuardar || !user?.uid;

  return (
    <form onSubmit={handleSubmit} method="post" className="bg-neutral-200 p-4 rounded-lg relative w-25">
      {/* Show company name from context */}
      <h2 className="text-lg font-semibold text-gray-900 mb-2">
        {companyProfile?.nome || "Empresa"}
      </h2>
      <p className="text-sm text-gray-600 mb-6">Use apenas informações verdadeiras sobre o produto.</p>

      {/* NOME */}
      <div className="mb-4">
        <label htmlFor="produto" className="block text-sm font-medium">Nome do Produto</label>
        <input
          id="nameProduto"
          name="nameProduto"
          value={formData.nameProduto}
          onChange={handleChange}
          required
          className="w-full rounded-md px-3 py-2"
        />
      </div>

      {/* DESCRIÇÃO */}
      <div className="mb-4">
        <label htmlFor="description" className="block text-sm font-medium">Descrição</label>
        <textarea
          id="description"
          name="description"
          rows="3"
          value={formData.description}
          onChange={handleChange}
          className="w-full rounded-md px-3 py-2"
        />
      </div>

      {/* PREÇO */}
      <div className="mb-4">
        <label htmlFor="price" className="block text-sm font-medium">Preço</label>
        <input
          id="price"
          type="number"
          name="price"
          step="0.01"
          min="0"
          value={formData.price}
          onChange={handleChange}
          required
          className="w-full rounded-md px-3 py-2"
        />
      </div>

      {/* SELECTS (Categoria/Sub/Especificação/Moeda) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        {/* Categoria */}
        <select
          name="tipo"
          value={categoriaAtiva}
          onChange={(e) => {
            const categoria = e.target.value;
            setCategoriaAtiva(categoria);
            setSubcategoriaAtiva("");
            setProdutosAtivos([]);
            handleChange(e); // sincroniza formData.type
          }}
          required
          disabled={loadingMenu || !!loadError}
          className="rounded-md px-3 py-2"
        >
          <option value="">{loadingMenu ? "Aguarde..." : "Categorias"}</option>
          {categorias.map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        {/* Subcategoria */}
        <select
          name="subtype"
          value={subcategoriaAtiva}
          onChange={(e) => {
            const sub = e.target.value;
            setSubcategoriaAtiva(sub);
            handleChange(e); // sincroniza formData.subtype
          }}
          required
          disabled={!categoriaAtiva}
          className="rounded-md px-3 py-2"
        >
          <option value="">{categoriaAtiva ? "Subcategoria" : "Selecione uma categoria"}</option>
          {subcategorias.map((sub) => (
            <option key={sub} value={sub}>{sub}</option>
          ))}
        </select>

        {/* Produto (Especificação) */}
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
          disabled={!subcategoriaAtiva}
          className="rounded-md px-3 py-2"
        >
          <option value="">{subcategoriaAtiva ? "Especificação" : "Selecione uma subcategoria"}</option>
          {produtosAtivos.map((prod) => {
            const nomeProduto = prod.Produto ?? prod.produto ?? prod.name ?? prod.title ?? "(sem nome)";
            return (
              <option key={prod.id} value={nomeProduto}>
                {nomeProduto}
              </option>
            );
          })}
        </select>

        {/* Moeda */}
        <select
          name="currency"
          value={formData.currency}
          onChange={handleChange}
          required
          className="rounded-md px-3 py-2"
        >
          <option value="">Moeda</option>
          <option value="USD">USD</option>
          <option value="KZ">Kwanza</option>
          <option value="ZAR">Rand</option>
        </select>
      </div>

      {/* NOVOS CAMPOS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        {/* Tipo de artigo */}
        <select
          name="tipoArtigo"
          value={formData.tipoArtigo}
          onChange={handleChange}
          required
          className="rounded-md px-3 py-2"
        >
          <option value="">Seleciona o tipo de artigo</option>
          <option value="Produto">Produto</option>
          <option value="Agenda">Agenda</option>
        </select>

        {/* Destino de venda */}
        <select
          name="destinoVenda"
          value={formData.destinoVenda}
          onChange={handleChange}
          required
          className="rounded-md px-3 py-2"
        >
          <option value="">Seleciona onde queres vender</option>
               {pais?.map((p, id)=>(  
          p?.paises.map((c,i)=>(
   <option key={i} value={c}>{c}</option>

          ))    
          ))}

        </select>

        {/* Taxa */}
        <select
          name="taxa"
          value={formData.taxa}
          onChange={handleChange}
          required
          className="rounded-md px-3 py-2"
        >
           <option value="">Taxa</option>
        {taxa?.map((t, id)=>(  
          t?.taxa.map((c,i)=>(
   <option key={i} value={c}>{c}</option>

          ))    
          ))}

        </select>

        {/* Tamanho e Cor */}

        <div>  
        <input
          type="text"
          placeholder="Tamanho"
          onBlur={(e) => addsizeAlt(e.target.value)}
          className="rounded-md px-3 py-2"
         

        />

          {formData.size.map((size)=>(

              <span
               className="inline-flex items-center bg-white text-gray-600 border rounded px-1 py-1"
              >
                  {size}


                  <button
                   className="text-red-600 hover:text-red-800"
                  onClick={()=>{removesizeAlt(size)}}>Remover</button>

         </span>



          ))}
       
</div>


    <div>   
        <input
          type="text"
          placeholder="Cor"
          onBlur={(e) => addcolorAlt(e.target.value)}
          className="rounded-md px-3 py-2"
        />

          {formData.color.map((cor)=>(

              <span
               className="inline-flex items-center bg-white text-gray-600 border rounded px-1 py-1"
              >
                  {cor}


                  <button
                   className="text-red-600 hover:text-red-800"
                  onClick={()=>{removecolorAlt(cor)}}>Remover</button>

         </span>



          ))}
       


        </div>


      </div>

      {/* IMAGENS */}
      <div className="mb-4">
        <label htmlFor="img" className="block text-sm font-medium">Imagem Principal (URL)</label>
        <input
          id="img"
          type="url"
          name="img"
          value={formData.img}
          onChange={handleChange}
          placeholder="https://..."
          className="w-full rounded-md px-3 py-2"
          required
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium">Imagens Secundárias (URLs)</label>

        <input
          type="url"
          placeholder="Cole a URL e saia do campo para adicionar"
          onBlur={(e) => addImageAlt(e.target.value)}
          className="w-full rounded-md px-3 py-2 mb-2"
        />

        <input
          type="url"
          placeholder="Outra URL (opcional)"
          onBlur={(e) => addImageAlt(e.target.value)}
          className="w-full rounded-md px-3 py-2"
        />

        {formData.imgAlt?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {formData.imgAlt.map((url) => (
              <span key={url} className="inline-flex items-center bg-white text-gray-800 border rounded px-2 py-1">
                <a href={url} target="_blank" rel="noreferrer" className="underline mr-2 truncate max-w-[220px]">
                  {url}
                </a>
                <button
                  type="button"
                  onClick={() => removeImageAlt(url)}
                  className="text-red-600 hover:text-red-800"
                >
                  Remover
                </button>
              </span>
            ))}
          </div>
        )}
      </div>

      {/* ERRO DE CARREGAMENTO */}
      {loadError && (
        <div className="mb-4 text-sm text-red-700">
          {loadError}
        </div>
      )}

      {/* BOTÕES */}
      <div className="flex justify-end gap-4">
        <button
          type="reset"
          className="text-sm text-gray-700"
          onClick={() => {
            setFormData({
              fornecedor:companyProfile?.nome,
          nameProduto: "",
          description: "",
          price: "",
          tipo: "",            // categoria
          category: "",        // especificação do produto
          subtype: "",         // subcategoria
          currency: "",
          imgAlt: [],          // array de URLs
          img: "",
          idSupplier: null,    // vem do user.uid
          transportadora: ["Tou Aki Express"],
          // Novos campos:
          tipoArtigo: "",      // Produto, Agenda...
          destinoVenda: "",    // Apenas Angola, Todos os Países...
          taxa: "",            // "0.05", "0.10", etc.
          size: [],
          color:[],
            });
            setCategoriaAtiva("");
            setSubcategoriaAtiva("");
            setProdutosAtivos([]);
          }}
        >
          Cancelar
        </button>

        <button
          type="submit"
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-500 disabled:opacity-50"
          disabled={isDisabled}
        >
          {btnGuardar ? "A Guardar..." : "Guardar Produto"}
        </button>
      </div>
    </form>
  );
}
